"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicDrawContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.publicDrawContract = c.router({
    getDrawTypeCached: {
        method: 'GET',
        path: '/draw-type/:draw_code',
        responses: {
            200: zod_1.z.object({
                draw_type: models_1.ZDrawTypeSelect,
                draw_type_plans: zod_1.z.array(models_1.ZDrawTypePlanSelect),
                draw_schedules: zod_1.z.array(models_1.ZDrawScheduleSelect),
                next_draw: zod_1.z.optional(models_1.ZDrawSelect),
            }),
            404: c.type(),
        },
    },
    getDrawTypeGroup: {
        method: 'GET',
        path: '/draw-type/group/:group',
        responses: {
            200: zod_1.z.array(zod_1.z.object({
                draw_type: models_1.ZDrawTypeSelect,
                draw_type_plan: models_1.ZDrawTypePlanSelect,
                draw_schedule: models_1.ZDrawScheduleSelect,
                draw: models_1.ZDrawSelect,
            })),
            404: c.type(),
        },
    },
    calcDrawCost: {
        method: 'GET',
        path: '/draw-type/:draw_code/cost',
        responses: {
            200: zod_1.z.object({
                draw_type: models_1.ZDrawTypeSelect,
                draw_type_plans: zod_1.z.array(models_1.ZDrawTypePlanSelect),
                next_draw: zod_1.z.optional(models_1.ZDrawSelect),
            }),
            404: c.type(),
        },
    },
    getDrawResults: {
        method: 'GET',
        path: '/results',
        query: zod_1.z.object({
            limit: zod_1.z.optional(zod_1.z.coerce.number()),
            draw_code: zod_1.z.optional(zod_1.z.string()),
        }),
        responses: {
            200: models_1.ZGetDrawResults,
        },
    },
    getDrawResult: {
        method: 'GET',
        path: '/result',
        query: zod_1.z.object({
            draw_id: zod_1.z.optional(zod_1.z.coerce.number()),
            draw_code: zod_1.z.optional(zod_1.z.string()),
        }),
        responses: {
            200: models_1.ZDrawResult,
            404: c.type(),
        },
    },
    getDrawRangesByDrawId: {
        method: 'GET',
        path: '/range/:draw_id',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        responses: {
            200: zod_1.z.object({
                ballRanges: zod_1.z.array(zod_1.z.number()),
                usingBonusBall: zod_1.z.boolean(),
            }),
        },
    },
    getTokenTownResults: {
        method: 'GET',
        path: '/token-town-results',
        responses: {
            200: zod_1.z.array(models_1.ZDrawAndPrizeResult),
        },
    },
}, {
    pathPrefix: '/public',
    strictStatusCodes: true,
});
//# sourceMappingURL=draw.public.contract.js.map